import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["trigger", "menu"];

  connect() {
    this.boundOutside = this.handleOutside.bind(this);
    this.boundKey = this.handleKey.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutside, true);
    document.removeEventListener("keydown", this.boundKey, true);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen ? this.close() : this.open();
  }

  open() {
    document.querySelectorAll(".kebab-menu[data-open='true']").forEach((m) => {
      if (m !== this.menuTarget) {
        m.dataset.open = "false";
        const trig = m.parentElement.querySelector(".kebab-trigger");
        if (trig) trig.setAttribute("aria-expanded", "false");
      }
    });
    this.menuTarget.dataset.open = "true";
    this.triggerTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.boundOutside, true);
    document.addEventListener("keydown", this.boundKey, true);
  }

  close() {
    this.menuTarget.dataset.open = "false";
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.boundOutside, true);
    document.removeEventListener("keydown", this.boundKey, true);
  }

  get isOpen() {
    return this.menuTarget.dataset.open === "true";
  }

  handleOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  handleKey(event) {
    if (event.key === "Escape") {
      this.close();
      this.triggerTarget.focus();
    }
  }
}
